(ns manage.content-configuration-page.placeholder.type
  (:require [re-frame.core :as rf]))

(def type->label
  {:text "Text"
   :image "Image"
   :video "Video"
   :audio "Audio"
   :click "Click"
   :impression-tracker "Impression tracker"
   :click-tracker "Click tracker"
   :collection "Collection"})

(defn icon [placeholder-type]
  (get {:text "text_fields"
        :image "image"
        :video "videocam"
        :audio "audiotrack"
        :click "link"
        :impression-tracker "view_agenda"
        :click-tracker "contacts"
        :collection "article"}
       placeholder-type "code"))

(defn type-option [placeholder-type]
  {:value (name placeholder-type)
   :label (get type->label placeholder-type)
   :icon (icon placeholder-type)})

(rf/reg-sub :placeholder/icon
  ;; this subscription accepts flexible input. Allowed inputs are:
  ;; - a datascript db entity id
  ;; - a map containing a value (type: keyword) for :placeholder/type
  ;; - a keyword indicating placeholder type
  (fn [[_ p]]
    (rf/subscribe [:ui.store/value p :placeholder/type]))
  (fn [placeholder-type-from-db [_ {placeholder-type-attribute :placeholder/type :as placeholder-type-as-keyword}]]
    (icon (or placeholder-type-from-db placeholder-type-attribute placeholder-type-as-keyword))))

(rf/reg-sub :placeholder/type-option
  (fn []
    (map type-option (keys type->label))))

(rf/reg-sub :placeholder/collection-type-options
  (fn []
    (map type-option [:text :image :video :audio :click])))
